export default function auth({ next, router }) {
  if (!sessionStorage.getItem('token')) {
    console.log('not authenticated');
    return router.push({ name: 'base' });
  }

  return next();
}
